<script setup lang="ts">
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
	Drawer,
	DrawerTrigger,
	IconButton,
} from '@laam/ui/base';
import { PhSlidersHorizontal, PhX } from '@phosphor-icons/vue';
import DrawerContent from '../../../../../packages/ui/components/base/drawer/DrawerContent.vue';
import SortList from './SortList.vue';

interface BrandSort {
	sortOptionSelected: string;
}
defineProps<BrandSort>();
const open = ref(false);
</script>
<template>
	<Drawer v-if="isMobileView()" v-model:open="open">
		<DrawerTrigger>
			<IconButton size="sm" variant="secondary">
				<PhSlidersHorizontal />
			</IconButton>
		</DrawerTrigger>
		<DrawerContent class="w-full">
			<div class="flex flex-col gap-3xl">
				<div class="flex items-center justify-between">
					<p class="text-gray-900 text-lg font-semibold">Sort By</p>
					<IconButton size="sm" variant="tertiary" @click="open = false">
						<PhX />
					</IconButton>
				</div>

				<SortList
					:sort-option-selected="sortOptionSelected"
					@update="open = false"
				/>
			</div>
		</DrawerContent>
	</Drawer>
	<Dialog v-else v-model:open="open">
		<DialogTrigger>
			<IconButton size="sm" variant="secondary">
				<PhSlidersHorizontal />
			</IconButton>
		</DialogTrigger>
		<DialogContent class="w-[30%]" :show-close="false">
			<DialogHeader class="flex-row align-middle justify-between !p-0">
				<DialogTitle class="text-gray-900">Sort By</DialogTitle>
				<DialogClose>
					<IconButton size="sm" variant="tertiary">
						<PhX />
					</IconButton>
				</DialogClose>
			</DialogHeader>
			<SortList
				:sort-option-selected="sortOptionSelected"
				@update="open = false"
			/>
		</DialogContent>
	</Dialog>
</template>
